(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-rituel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bundle-rituel')) {
  customElements.define(
    'bundle-rituel',
    class BundleRituel extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-bundle-add]');
        this.errorEl = this.querySelector('.bundle-rituel__error');
        this.spinner = this.querySelector('.loading__spinner');
        this.loading = false;

        if (this.button && !this.button.disabled) {
          this.button.addEventListener('click', this.onClick.bind(this));
        }
      }

      onClick() {
        if (this.loading) return;

        // Un attribut « data-variant-id-1 » ne devient PAS this.dataset.variantId1 :
        // un tiret suivi d'un chiffre n'est jamais converti en camelCase par le
        // navigateur (seul un tiret suivi d'une lettre l'est). La vraie cle est
        // « variantId-1 », avec le tiret, illisible en notation pointee. Resultat
        // avec dataset.variantId1 : toujours undefined, ATC toujours refuse comme
        // « indisponible » quel que soit le vrai stock. getAttribute() n'a pas ce
        // probleme, on lit l'attribut HTML directement.
        const items = [];
        const id1 = parseInt(this.getAttribute('data-variant-id-1'), 10);
        const id2 = parseInt(this.getAttribute('data-variant-id-2'), 10);
        if (id1) items.push({ id: id1, quantity: 1 });
        if (id2) items.push({ id: id2, quantity: 1 });

        if (items.length < 2) {
          this.showError(this.getAttribute('data-error-unavailable'));
          return;
        }

        this.setLoading(true);
        this.hideError();

        const cart =
          document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items: items };

        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${window.routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'bundle-rituel',
                cartData: response,
              });
            }

            if (this.dataset.cartBehaviour === 'page') {
              window.location = window.routes.cart_url;
              return;
            }

            if (cart && typeof cart.renderContents === 'function') {
              if (typeof cart.setActiveElement === 'function') cart.setActiveElement(this.button);
              cart.classList.remove('is-empty');
              cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch(() => {
            this.showError(this.getAttribute('data-error-generic'));
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(state) {
        this.loading = state;
        if (!this.button) return;
        this.button.classList.toggle('loading', state);
        this.button.setAttribute('aria-disabled', state);
        if (this.spinner) this.spinner.classList.toggle('hidden', !state);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
